import scIcon from './scIcon.vue';

export default {
  install(Vue) {
    Vue.component('scIcon', scIcon);
  },
};
